import React, { useState, useEffect } from "react";
import Table from "react-bootstrap/Table";
import Modal from 'react-bootstrap/Modal';
import UserService from '../../services/user.service';
import { useForm } from "react-hook-form";

const MailHistoryModal = (props) => {
    const [emailHistory, setEmailHistory] = useState([]);
  const { register, handleSubmit, formState: { errors } } = useForm({
    defaultValues: {email: props.user.email, userId: props.user.id},
  });

  useEffect(() => {
    console.log(props.user);
    function fetchEmailHistory() {
      UserService.getEmailHistory(props.user.id).then(
        (response) => {
          console.log(response);
          setEmailHistory(response.data);
        },
        (error) => {
          const resMessage =
            (error.response &&
              error.response.data &&
              error.response.data.message) ||
            error.message ||
            error.toString();
          console.log(resMessage);
        }
      );
    }
    fetchEmailHistory();
  }, []);

  const formatDate = (date) => {
    var hours = date.getHours();
    var minutes = date.getMinutes();
    var ampm = hours >= 12 ? 'pm' : 'am';
    hours = hours % 12;
    hours = hours ? hours : 12; // the hour '0' should be '12'
    minutes = minutes < 10 ? '0'+minutes : minutes;
    var strTime = hours + ':' + minutes + ' ' + ampm;
    return (date.getMonth()+1) + "/" + date.getDate() + "/" + date.getFullYear() + "  " + strTime;
  }
  
  const formatType = (typeId) => {
    if(typeId === 1) return "Registration";
    else if(typeId === 2) return "New Items Report";
    else if(typeId === 3) return "Open Orders Report";
  }

  return (
    <Modal show={props.show} onHide={props.close}>
    <Modal.Header closeButton>
      <Modal.Title>Email History<br/></Modal.Title>
    </Modal.Header>
    <Modal.Body>
        <Table>
            <thead>
              <tr>
                <th>Email</th>
                <th>Date</th>
              </tr>
            </thead>
            <tbody>
              {emailHistory && emailHistory.map((email) => (
                <tr key={email.id}>
                  <td>{formatType(email.emailTypeId)}
                        </td>
                  <td>{formatDate(new Date(email.sentDate))}</td>
                </tr>
              ))}
            </tbody>
        </Table>
    </Modal.Body>
    </Modal>
  );
};

export default MailHistoryModal; 